import React from 'react';
import {
  InterviewContentsWrapper,
  InterviewQuestion,
  InterviewHR,
  InterviewP,
  InterviewTalk,
  InterviewAnswer,
  InterviewH2,
  InterviewImg,
  InterviewGuideToRelatedArticle,
  InterviewYoutubeVideo,
  InterviewVimeoVideo,
} from '~/components/interview/atoms';
import suzuki2Img1 from '~/assets/images/interview/suzuki2_img1.jpg';
import { useIsJapanese } from '~/hooks';

export const Suzuki2Contents = () => {
  const isJapanese = useIsJapanese();
  const vimeoURL =
    'https://player.vimeo.com/video/94216637?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';
  const youtubeURL =
    'https://www.youtube.com/embed/X8ulX6juG9E?si=dx7PKFShLiGT1Av8';

  return (
    <InterviewContentsWrapper>
      {isJapanese ? (
        <>
          <InterviewP>
            SAFEHOUSEの取締役として『ファイナルファンタジー XVI』や『BIOHAZARD
            INFINITE DARKNESS』『機動戦士ガンダム
            復讐のレクイエム』などを手掛けてきた鈴木さん。背景アーティストとして国内外の作品に参加する一方で、後進の育成に力を注いでいます。アーティストとしての成長やこれからの背景制作についてお話を伺いました。
          </InterviewP>
          <InterviewHR />
          <InterviewTalk>
            <InterviewQuestion>
              鈴木さんのアーティストとしての強みを教えてください。
            </InterviewQuestion>
            <InterviewAnswer>
              僕は、アートに関しての知識ゼロでこの業界に入りました。絵は書いたことがないですし、デッサンすらほぼなしです。Blizzard
              Entertainmentで働く人たちは表現することがライフスタイルの一部になっているような人が多くて、学生の頃から美術をしっかり学んできた人や、CGの仕事をやりながら趣味でカメラを深く勉強している人や彫刻などアナログなことに取り組んでいる人とかがいます。そんな中「ソフトが使えて、背景が作れて、カッコいいものが作れる」で入社した僕のポジションは野球で言うとイチロータイプです（笑）。「ホームランは打たないけれど、打率は高い」。一発でスッゲーかっこいいものをバーンと出せるわけではないけれど、鈴木に任せておけば確実にいいものができるという立ち位置です。「アートディレクターの言っていることを噛み砕くとこうなる」「あちらの言っていることを取り入れるには……」と。そして最終的に「自分はこの場面の背景はこうしたい！」というイメージに仕上げていくわけです。ディレクターたちの希望に添えるように適時打を打って塁に出る。自分はこうやりたいという思いで盗塁をする。ヒットの延長でホームランをうつことあるけど、しっかり点に絡む動きをするというところでBlizzard
              Entertainmentでのポジションを築いていきました。
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              美術的なことを学ばなくてもアーティストになれますか？
            </InterviewQuestion>
            <InterviewAnswer>
              やり方を変えて補うことができると考えています。例えばデッサンは観察力を養う作業ですよね。だから、目で見たものを頭で理解して、それを分解して再構築してアウトプットする。ペンがマウスに変わるだけで、頭の中では同じことをしています。ただ、人よりも数をこなして来たつもりです。あと、僕がいつもやっているのは三面図を使わず、一枚のパースから形を取ることをやっています。三面図使ったら誰でも形を取れちゃうから負荷をかけるんです（笑）。要は比率や奥行きを頭で想像してデジタルで造形していく。僕はモデリングをするときに、人よりも「足かせ」をつけてやっているということです。そのことで美術的な素養をカバーしているつもりですし、他のアーティストとは違うアプローチが個性になるのかもしれませんね。
            </InterviewAnswer>
            <InterviewVimeoVideo
              src={vimeoURL}
              caption="2014年作成のデモリール"
              title="Takuya Suzuki 2014 Modeling Reel"
            />
          </InterviewTalk>
          <InterviewHR />
          <InterviewH2>
            小規模の会社でもリアルな映像を作れる会社は増えてきています。ただ、それを使ってカッコいいモノを作れるところは限られます
          </InterviewH2>
          <InterviewTalk>
            <InterviewQuestion>
              Unreal Engineでの制作には元々注目していましたか？
            </InterviewQuestion>
            <InterviewAnswer>
              元々リアルタイムには全く興味がありませんでした。Blizzard
              Entertainmentにいた時も何回かリアルタイムエンジンで作った映像を見たことがあったんですけど、ゲームっぽかったんですよね。結局ハリウッドスタイルのパソコンにシミュレーションをかけて計算させるクオリティには絶対追いつけないと思っていました。それから数年後、今SAFEHOUSEでアートディレクターをしている、エラスマス・ブロスダウに出会うことになったんです。彼がUnreal
              Engineで作ったリアルタイムレンダリングの映像を見て驚きました。今まで見たことがないくらいクオリティが高くて、これなら実際に使えるかもしれないと思いましたし、入れ替わる時代が来るんだと感じました。
            </InterviewAnswer>
            <InterviewYoutubeVideo
              src={youtubeURL}
              caption="エラスマス・ブロスダウが手がけるUnreal Engineで制作したデジタルヒューマン"
            />
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              リアルタイムエンジンでの制作はSAFEHOUSEの強みになりますか？
            </InterviewQuestion>
            <InterviewAnswer>
              発注者側からの要望も増えていますし、リアルタイムエンジンで映像を作れることは大きなアドバンテージになると思います。ただ、プリレンダリングの仕事ももちろんやっていますし、リアルタイムレンダリングという手法だけにこだわっているわけではないです。絵づくりを常に意識してやっていますね。すごくリアルなビルを作れる会社はかなり出てきていますが、そのビルをどういう風に配置するとカッコよく見えるかという表現力を持ち合わせたところは多くないんです。リアルだけだと面白くない。アートとして作り上げる技術は別にあるんでしょうね。UnrealEngineを使うことでそういった絵作りという表現がリアルタイムで描写されることはアーティストにとってかなり大きなアドバンテージだと思っています。小さな規模でしっかりとした自分たちの表現を持っているという意味でSAFEHOUSEは唯一無二だと思います。
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              仕事で喜びを感じる時はどんな時ですか？
            </InterviewQuestion>
            <InterviewAnswer>
              仕事を通じてクライアントの価値観を変えられた時はすごく嬉しいですね。あるクライアントのアニメの撮影監督さんが「僕はCGの背景はあんま信じていない。どうしてもデータとして見てしまう」と言っていたんです。要するに2Dのペインターによる感情表現にCGは勝てないと。ところが僕たちが作った背景をみて「今までの価値観が変わった」と言ってもらえました。すごく嬉しかったですね！
              20年間CG制作をやってきて一番嬉しかった言葉です。自分のやってきたことは間違ってなかったと思えました。僕たちの作る背景には人の価値観を変える力があると確信しました。
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              社外でもセミナーなどをしていますが、教育活動が好きなんですか？
            </InterviewQuestion>
            <InterviewImg src={suzuki2Img1} />
            <InterviewAnswer>
              好きという感情とは少し違うかもしれませんね。スクウェア・エニックスの時も、Blizzard
              Entertainmentの時も教えてもらえる環境に恵まれていました。スクウェア・エニックスの時はすごくいい先輩がいて、一からちゃんと教えてくれました。一方で放置されてくすぶる同僚の姿も実際に見てきました。先ほどもお話ししましたけど、Blizzard
              Entertainmentではアーティストたちが持っている技術や考え方を惜しみなく自分に注いでくれました。そうやって育てられたので、僕もスーパーバイザーとして、先輩として人を育てないといけないという使命感があります。
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewHR />
          <InterviewH2>
            学生時代はアートブックを買い漁ってました。今もCGにアニメ的な多視点を取り入れられないか研究していますよ！
          </InterviewH2>
          <InterviewTalk>
            <InterviewQuestion>
              どんな作品に影響を受けてきましたか？
            </InterviewQuestion>
            <InterviewAnswer>
              実は兄貴も映画などのCGをやっていて、それで映像にも興味を持ち始めたんです。映画で一番影響を受けたのは『スター・ウォーズ／ファントム・メナス
              (エピソード1)』。作品を観たのは20歳くらいだったと思うんですが、その時の衝撃もすごかったですね。表現がチープに響いてしまうかもしれませんが「世界が存在している」って思いました。それからスターウォーズ展に行ったり、アートブックを買ったりしました。あの頃は元のデザイン画や、どういうふうに立体化したかを知りたくて、色々な作品のアートブックを買い漁ってましたね。お金もそんなになかったので、図書券をもらうために町中でおばちゃんがやってるインタビューを受けたりして……一回で1,500円分もらえたんですよ（笑）。あの頃は泥臭い勉強の仕方をしてました。多分美術を専門的に学んでいないことのコンプレックスで、それを埋めようと必死だったんだと思います。
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              今でも創作のために勉強をしていますか？
            </InterviewQuestion>
            <InterviewAnswer>
              今は手札が色々あるし、自分に足りないものもわかっているつもりです。なのでその部分を勉強しているって感じですね。昔は映画館でCGをふんだんに使った派手な映画をを見るのがすごく好きだったんですけど、今はそういった映画をあまり見に行かなくなってしまいました。若い頃は結局自分の知らない技術を学ぶために映画館に行っていたんだと思います。だから、自分が映画と同じクオリティのものが作れるようになって、どうやってこれ作っているんだろうという発見が、CGを前面に押し出した映画から離れていってしまった理由かもしれません。今は色使いがきれいとか、カメラの見せ方が良い、世界観が好きとか、CGのモデリング技術ではなくそういった演出の所で映画を見ることがおおいです。今は技術優先からその技術を使ってどう表現すると人は感動するのかというところに興味がシフトしている感じです。例えばピクサーとかディズニーとかってすごいじゃないですか。万人に受ける作品を作り続けてる。彼らの作品から、技術を使ってどう表現するかや、ストーリーを際立たせるための背景表現について学んでいます。ジブリの背景は多視点だったりするんですけど、16:9のフレームの中により多くの情報を内包させて、見る人の想像を促すためになんですけど、この仕組みがカッコ良さや空間の広さを感じさせて感動をうむわけです。ところがこれって僕たちがいつもやっているフォトリアルなCG作品では不可能なんですよ。リアルなものができてしまうので……。アニメ作品にある、普段見ている以上の情報を、脳に処理させるような仕組みをCGでやるにはどうすればいいのか、ここを研究しています。
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              今後、背景の制作者は何が求められると思いますか？
            </InterviewQuestion>
            <InterviewAnswer>
              すごく難しいんですが……結局AIが出てくると「モノを作る」という工程は少なくなってくると思います。これは随分前から思っていて、その時に僕たちがすべきことはAIが作ったものに対して、それが良いのか悪いのかをちゃんとジャッジをすることです。AIが作った絵に対して単純に「カッコいい」とか、評価するのではなく、ストーリーラインにそっているかというところで判断することが重要です。そこをジャッジできるのは人間だけですから。AIが作ったデータは人間が見る作品の映像としてデータを作り替えないといけません。だからモデルが上手に作れるということよりも、そのモデルをどういうふうに見せれば良い映像になるかを考え、モデルを作った先の表現ができることがより重要になっていくと思います。カッコいいものがなぜカッコいいと感じるのかを自分で理解して、意図的にそれを出せるようになる。CGの制作者はそこを求められるようになると思います。
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              最後にSAFEHOUSEで働くことに興味がある人にメッセージをお願いします。
            </InterviewQuestion>
            <InterviewAnswer>
              少し臭いセリフになってしまうんですが、新卒、中途に関わらず背景に愛を持って取り組める人と一緒に仕事がしたいです。「自分の表現で作品を良くしよう」みたいな人です。自分の世界観を表現したり、背景でストーリーを伝えたい人。ただ作るだけじゃなくて、自分なりの表現を持っている人がいいですね。ただ、自分の世界に固執するわけでもなく、自分のアートをエンターテインメントとして世界中の人に喜んでもらえるように、いろんな意見を柔軟に取り入れて自分を変えることのできる人。そういう考えの人と一緒に作品を作っていきたいです！
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewGuideToRelatedArticle href="/interview/suzuki1/">
            鈴木卓矢さんのインタビュー前編はこちら
          </InterviewGuideToRelatedArticle>
        </>
      ) : (
        <>
          <InterviewP>
            As SAFEHOUSE's director, Takuya Suzuki has contributed his
            background artistry expertise to prestigious titles including FINAL
            FANTASY XVI, RESIDENT EVIL: INFINITE DARKNESS, and Gundam: Requiem
            for Vengeance. While collaborating on major productions across
            global markets, he remains committed to mentoring emerging talent.
            In this interview, he reflects on his artistic evolution and shares
            his vision for the future of background design.
          </InterviewP>
          <InterviewHR />
          <InterviewTalk>
            <InterviewQuestion>
              What are your strengths as an artist?
            </InterviewQuestion>
            <InterviewAnswer>
              I entered the industry with no prior knowledge of art. Blizzard
              Entertainment is full of people who express themselves creatively
              in many ways. Some are formally trained artists, others pursue
              passions like photography alongside their CG work, and still
              others explore analog art forms like sculpture. I joined the
              company because I could use software to create backgrounds and
              make cool things, and I feel like Ichiro in baseball (laughs). “I
              may not hit home runs, but I have a solid batting average.” I
              might not be able to produce something amazing all at once, but if
              you let me handle it, you can definitely count on me to create
              something great. I would say things like, “This is what the art
              director is referring to,” or “To incorporate that idea, I would
              go to...".
              <br />
              <br />
              My goal is to create a visual that says, 'Here's exactly the
              background this scene needs!' I make sure to hit my bases –
              delivering what the directors want, precisely when they need it. I
              might steal a base now and then, taking a calculated risk because
              I believe it'll advance the scene. Sometimes that leads to a home
              run, exceeding expectations. But my career at Blizzard
              Entertainment has been built on consistently getting on base –
              making solid, reliable contributions that score points for the
              team.
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              Is it possible to be an artist without having studied fine arts?
            </InterviewQuestion>
            <InterviewAnswer>
              I believe we can make up for this by changing our approach. For
              instance, drawing helps develop observation skills. You need to
              understand what you see, break it down in your mind, and then
              recreate it. I do the same process in my head, but instead of a
              pen, I use a mouse. I think I've practiced this more than most
              people. Additionally, I always take a shape from a single
              perspective rather than relying on three-view plans
              (front/elevation view, top/plan view and end/profile view). If I
              used three-view drawings, anyone could replicate the shape, so I
              put in extra effort (laughs). Essentially, I visualize the
              proportions and depths in my mind before creating the shape
              digitally. When I model, I impose more “constraints” on myself
              than others do. I believe this helps compensate for my artistic
              background, and my unique approach may be what sets me apart from
              other artists.
            </InterviewAnswer>
            <InterviewVimeoVideo
              src={vimeoURL}
              caption=" 2014 Demo Reel"
              title="Takuya Suzuki 2014 Modeling Reel"
            />
          </InterviewTalk>
          <InterviewHR />
          <InterviewH2>
            “More and more small companies are able to create realistic images,
            but they often struggle to produce truly impressive work. However,
            there are only a few companies that can actually make those
            impressive creations.”
          </InterviewH2>
          <InterviewTalk>
            <InterviewQuestion>
              Were you initially interested in working with Unreal Engine?
            </InterviewQuestion>
            <InterviewAnswer>
              Initially, I had no interest in real-time technology. While I had
              seen some videos made with real-time engines during my time at
              Blizzard Entertainment, they looked like games to me. I felt I
              could never match the quality of Hollywood-style visuals created
              with complex simulations and calculations. A few years later, I
              met Erasmus Brosdau, who is now the art director at SAFEHOUSE. I
              was blown away by the real-time rendered images he created using
              Unreal Engine. The quality was incredible—something I had never
              seen before—and I realized that this technology could actually be
              utilized, signaling that a shift was about to happen.
            </InterviewAnswer>
            <InterviewYoutubeVideo
              src={youtubeURL}
              caption="Digital human created with Unreal Engine by Erasmus Brosdau."
            />
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              Does using a real-time engine give SAFEHOUSE an advantage in
              production?
            </InterviewQuestion>
            <InterviewAnswer>
              With client requests increasing, our real-time rendering
              capabilities offer a significant advantage. While I also utilize
              pre-rendering techniques, my focus remains on crafting compelling
              visuals, regardless of the method. Many companies can produce
              realistic architectural renderings, but few can effectively
              arrange those buildings to achieve a truly striking aesthetic.
              Pure realism isn't enough; it needs artistic expression. Unreal
              Engine empowers our artists to achieve this expressive quality in
              real time. At SAFEHOUSE, we pride ourselves on our unique artistic
              vision, even within the scope of smaller projects.
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              When do you feel happiest at work?
            </InterviewQuestion>
            <InterviewAnswer>
              It's incredibly rewarding when my work shifts a client's
              perspective. One animation cinematographer told me,”I've always
              been skeptical of CG backgrounds—they've always felt like mere
              data to me.” Essentially, he believed CG could never match the
              emotional depth of hand-painted 2D art.
              <br />
              <br />
              But after seeing our backgrounds, he admitted, “You've completely
              changed my perspective.” That moment was profoundly
              validating—perhaps the most meaningful feedback I've received in
              my twenty years creating CG. It confirmed that our approach wasn't
              just technically sound but could genuinely move people and
              transform how they perceive digital artistry.
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              You conduct seminars outside of the company as well; do you like
              teaching?
            </InterviewQuestion>
            <InterviewImg src={suzuki2Img1} />
            <InterviewAnswer>
              It might be a bit different from simply liking something. I was
              fortunate to have been in environments where I learned a lot, both
              at Square Enix and Blizzard Entertainment. At Square Enix, I had
              excellent mentors who taught me everything from the basics.
              However, I also witnessed colleagues who felt overlooked and
              frustrated. As I mentioned earlier, at Blizzard Entertainment, the
              artists were very generous in sharing their skills and ideas with
              me. Because of this background, I feel a strong sense of
              responsibility as a supervisor and senior team member to help
              train others.
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewHR />
          <InterviewH2>
            “When I was a student, I used to collect all sorts of art books. I'm
            still learning how to incorporate different perspectives into CG!”
          </InterviewH2>
          <InterviewTalk>
            <InterviewQuestion>
              Which works have had an impact on you?
            </InterviewQuestion>
            <InterviewAnswer>
              Visual arts first captured my interest through my brother, who
              works in cinematic CG. The film that truly transformed my
              perspective was 'Star Wars: The Phantom Menace.' I was around 20
              when I saw it, and its impact was profound—it sounds almost
              cliché, but I felt like I'd discovered an entirely new world.
              <br />
              <br />
              Afterward, I became obsessed, attending Star Wars exhibitions and
              collecting art books. I was particularly fascinated by the
              original concept designs and how they translated into
              three-dimensional spaces. Despite my limited budget, I found
              creative ways to fund my self-education—I even conducted street
              interviews with women around town to earn book vouchers. Each
              interview paid about 1,500 yen. Looking back, my approach to
              learning was rather unconventional. Perhaps it stemmed from my
              insecurity about lacking formal art training—I was determined to
              compensate through sheer persistence.
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              Do you still engage in study for your creative work?
            </InterviewQuestion>
            <InterviewAnswer>
              I've developed a diverse skill set over time, and now I can
              clearly see what areas I still need to strengthen. That's where my
              focus is now.
              <br />
              <br />
              When I was younger, I was drawn to cinemas for big-budget,
              CG-heavy spectacles—I was essentially educating myself on
              techniques I hadn't mastered yet. Once I could produce work of
              comparable quality, that technical curiosity was satisfied, and
              those flashy CG showcases lost their appeal.
              <br />
              <br />
              Now I watch films for entirely different reasons—thoughtful color
              palettes, masterful camera work, or compelling worldbuilding. My
              interests have evolved from the technology itself to how that
              technology can create genuine emotional responses.
              <br />
              <br />
              Look at Pixar and Disney—they've maintained universal appeal
              despite technological shifts. I study how they use technical
              elements to enhance storytelling and how environmental design
              reinforces narrative.
              <br />
              <br />
              Studio Ghibli's backgrounds are fascinating because they
              incorporate multiple perspectives within a single frame. This
              approach packs more information into the standard 16:9 aspect
              ratio and stimulates viewers' imagination. We can't replicate this
              in conventional photo-realistic CG—the visual contradiction would
              break immersion.
              <br />
              <br />
              We're now researching how CG might create frameworks that allow
              the brain to process information differently in animated works,
              beyond what we normally perceive.
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              What do you think will be expected of environment artists in the
              future?
            </InterviewQuestion>
            <InterviewAnswer>
              It’s quite challenging, but I believe that as AI continues to
              develop, the actual process of “making things” will diminish. In
              the future, our focus should shift to properly assessing whether
              what AI produces is good or bad, rather than just deciding if it’s
              “cool.” It’s crucial to determine if the visuals align with the
              storyline. Only humans can make that judgment, so AI-generated
              content must be refined into an image that resonates with the
              viewer.
              <br />
              <br />
              As a result, it will be increasingly important to consider how to
              present the model in order to create a compelling image, focusing
              on expressing the model's essence beyond just crafting a good
              model. CG creators will need to understand why certain things
              appear appealing and be able to intentionally convey that appeal
              in their work.
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewTalk>
            <InterviewQuestion>
              In closing, do you have a message for anyone considering a job at
              SAFEHOUSE?
            </InterviewQuestion>
            <InterviewAnswer>
              It might sound a bit sentimental, but I'm looking for
              collaborators who bring genuine passion to background
              artistry—whether they're just starting their careers or bringing
              years of experience. I want to work alongside people who aren't
              just technically proficient, but who genuinely love crafting
              environments that tell stories and convey distinct worldviews.
              <br />
              <br />I value artists who develop their own unique voice and
              expressive style. At the same time, the ideal colleague isn't
              rigid or self-contained—they remain open to feedback and willing
              to evolve. They understand that to create entertainment that
              resonates globally, you need to balance personal vision with
              flexibility.
              <br />
              <br />
              That's the kind of creative community I'm hoping to build—artists
              who combine individual perspective with collaborative spirit.
            </InterviewAnswer>
          </InterviewTalk>
          <InterviewGuideToRelatedArticle href="/en/interview/suzuki1/">
            Read the first part of Takuya Suzuki's interview here
          </InterviewGuideToRelatedArticle>
        </>
      )}
    </InterviewContentsWrapper>
  );
};
